import { render, staticRenderFns } from "./HealthProComp.vue?vue&type=template&id=07020a84&scoped=true"
import script from "./HealthProComp.vue?vue&type=script&lang=js"
export * from "./HealthProComp.vue?vue&type=script&lang=js"
import style0 from "./HealthProComp.vue?vue&type=style&index=0&id=07020a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07020a84",
  null
  
)

/* custom blocks */
import block0 from "./HealthProComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports